import React from 'react'
import img from '../../assets/img/Features/anim9.gif'
import img2 from '../../assets/img/Features/anaytics.svg'
export default function Section8() {
  return (
    <div class="py-16 bg-slate-900 overflow-hidden lg:py-5">
    <div class="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
    <div class="relative mt-12 sm:mt-16 lg:mt-10">
    <div class="lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:gap-8 lg:items-center">
      <div class="lg:col-start-2">
        <h3 class="text-xl lg:text-4xl font-bold text-white tracking-tight ">Timeline View & Notifications</h3>
        {/* <p class="mt-3 text-lg text-gray-500">Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit ex obcaecati natus eligendi delectus, cum deleniti sunt in labore nihil quod quibusdam expedita nemo.</p> */}

        <dl class="mt-10 space-y-10">
          <div class="relative">
            <dt>
              <div class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                {/* <!-- Heroicon name: outline/annotation --> */}
                <svg className=' h-6 w-6' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.25C7.71983 1.25 4.25004 4.71979 4.25004 9V9.7041C4.25004 10.401 4.04375 11.0824 3.65717 11.6622L2.50856 13.3851C1.17547 15.3848 2.19318 18.1028 4.51177 18.7351C5.26738 18.9412 6.02937 19.1155 6.79578 19.2581L6.79768 19.2632C7.56667 21.3151 9.62198 22.75 12 22.75C14.378 22.75 16.4333 21.3151 17.2023 19.2632L17.2042 19.2581C17.9706 19.1155 18.7327 18.9412 19.4883 18.7351C21.8069 18.1028 22.8246 15.3848 21.4915 13.3851L20.3429 11.6622C19.9563 11.0824 19.75 10.401 19.75 9.7041V9C19.75 4.71979 16.2802 1.25 12 1.25ZM15.3764 19.537C13.1335 19.805 10.8664 19.8049 8.62349 19.5369C9.33444 20.5585 10.571 21.25 12 21.25C13.4289 21.25 14.6655 20.5585 15.3764 19.537ZM5.75004 9C5.75004 5.54822 8.54826 2.75 12 2.75C15.4518 2.75 18.25 5.54822 18.25 9V9.7041C18.25 10.6972 18.544 11.668 19.0948 12.4943L20.2434 14.2172C21.0086 15.3649 20.4245 16.925 19.0936 17.288C14.4494 18.5546 9.5507 18.5546 4.90644 17.288C3.57561 16.925 2.99147 15.3649 3.75664 14.2172L4.90524 12.4943C5.45609 11.668 5.75004 10.6972 5.75004 9.7041V9Z" fill="#ffffff"></path> </g></svg>
              </div>
              <p class="ml-16 text-lg lg:text-xl leading-6 font-normal text-white">Track your progress over time and get reminders to ensure you're always on the path to improvement.</p>
            </dt>
           
          </div>

          <div class="relative">
            <dt>
              <div class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                {/* <!-- Heroicon name: outline/mail --> */}
                <img src={img2} className=' h-6 w-6'></img>
              </div>
              <p class="ml-16 text-lg lg:text-xl leading-6 font-normal text-white"> Enables organizations to visualize their progress, monitor improvements, and adjust strategies as necessary for continuous growth.</p>
            </dt>

          </div>
        </dl>
      </div>

      <div class="mt-10 -mx-4 relative lg:mt-0 lg:col-start-1">
    
        <img class="relative mx-auto" width="490" src={img} alt=""/>
      </div>
    </div>
  </div>
  </div>
  </div>
  )
}
